// Libellés de thèmes du TUTEUR, en français seulement.
//
// COPIE VOLONTAIRE de `src/themes.js`. La table publique alimente `THEME_SLUGS`,
// qui construit la barre de filtres vue par TOUS les visiteurs : y ajouter les
// quatre familles grammaticales du pipeline avait fait passer cette barre de 36
// à 40 filtres pour tout le monde. Le tuteur a donc la sienne, où ces quatre
// slugs figurent sans conséquence pour personne.
const LABELS = {
  'amour-relations': 'Amour et relations',
  'animaux': 'Animaux',
  'argent-commerce': 'Argent et commerce',
  'art-culture': 'Art et culture',
  'caractere-personnalite': 'Caractère et personnalité',
  'corps-sante': 'Corps et santé',
  'couleurs-formes': 'Couleurs et formes',
  'ecole-education': 'École et éducation',
  'emotions': 'Émotions',
  'famille': 'Famille',
  'guerre-armee': 'Guerre et armée',
  'justice-droit': 'Justice et droit',
  'langue-communication': 'Langue et communication',
  'liens-logiques': 'Liens logiques',
  'loisirs-jeux': 'Loisirs et jeux',
  'maison-quotidien': 'Maison et quotidien',
  'medias-information': 'Médias et information',
  'meteo-saisons': 'Météo et saisons',
  'mouvement-action': 'Mouvement et action',
  'musique': 'Musique',
  'nature': 'Nature',
  'nombres-mesures': 'Nombres et mesures',
  'nourriture-cuisine': 'Nourriture et cuisine',
  'pensee-esprit': 'Pensée et esprit',
  'perception-sens': 'Perception et sens',
  'politique-etat': 'Politique et État',
  'prepositions': 'Prépositions',
  'pronoms-questions': 'Pronoms et questions',
  'religion': 'Religion',
  'science': 'Science',
  'societe-gens': 'Société et gens',
  'sport': 'Sport',
  'technologie': 'Technologie',
  'temps-calendrier': 'Temps et calendrier',
  'travail-metiers': 'Travail et métiers',
  'verbes-essentiels': 'Verbes essentiels',
  'vetements': 'Vêtements',
  'vie-mort': 'Vie et mort',
  'ville-lieux': 'Ville et lieux',
  'voyage-transport': 'Voyage et transport',
};

export function themeLabel(slug) {
  return LABELS[slug] || slug;
}
